module.exports = __webpack_public_path__ + "img/w5.2f59bf68.jpg";